import { SERVER_URL } from "../../api";
import axios from 'axios';
import { getHeaderWithToken } from "../../helpers/func";

export const GET_SIZE_REQUEST = 'GET_SIZE_REQUEST';
export const GET_SIZE_SUCCESS = 'GET_SIZE_SUCCESS';
export const GET_SIZE_ERROR = 'GET_SIZE_ERROR';
export const RESET_GET_SIZE = 'RESET_GET_SIZE';


export const getSize = () => {
    let headers = getHeaderWithToken();

    return dispatch => {
        return new Promise(function (resolve, reject) {
            dispatch({
                type: GET_SIZE_REQUEST
            })
            axios({
                method: 'GET',
                url: `${SERVER_URL}v1/size`,
                headers: headers,

            }).then(function (response) {
                dispatch({
                    type: GET_SIZE_SUCCESS,
                    payload: response
                })
                resolve(response);
            })
                .catch(function (error) {
                    dispatch({
                        type: GET_SIZE_ERROR,
                        payload: error
                    })
                    reject(error)
                })
        })
    }
}



